import { render, staticRenderFns } from "./MyReviewView.vue?vue&type=template&id=5dec202c&scoped=true&"
import script from "./MyReviewView.vue?vue&type=script&lang=js&"
export * from "./MyReviewView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dec202c",
  null
  
)

export default component.exports